export const getDigitsFromValue = (value = '') =>
  value.replace(/(-(?!\d))|[^0-9|-]/g, '') || '';

const removeLeadingZeros = (number: string) =>
  number.replace(/^0+([0-9]+)/, '$1');

const addDecimalToNumber = (number: string, separator: string) => {
  const centsStartingPosition = number.length - 2;
  const amountValue = removeLeadingZeros(
    number.substring(0, centsStartingPosition),
  );
  const cents = number.substring(centsStartingPosition);
  return amountValue + separator + cents;
};

const toCurrency = (
  rawValue: string,
  alwaysZeroCents?: boolean,
  separator = '.',
) => {
  const applySlice = alwaysZeroCents && rawValue.split(',')[1]?.length === 1;
  const value = alwaysZeroCents
    ? applySlice
      ? rawValue.replace(',0', '').slice(0, applySlice ? -1 : undefined)
      : rawValue.replace(',00', '')
    : rawValue;
  const digits = getDigitsFromValue(value);

  const padDigits = (digitsValue: string) => {
    const desiredLength = 3;
    const actualLength = digitsValue.length;

    if (actualLength >= desiredLength) {
      return digitsValue;
    }

    const amountToAdd = desiredLength - actualLength;
    const padding = '0'.repeat(amountToAdd);

    return padding + digits;
  };

  const digitsWithPadding = padDigits(digits);
  const addDecimalWithZeroCents = (number: string, separatorValue: string) => {
    const amountValue = removeLeadingZeros(number);
    return amountValue + separatorValue + '00'; // Always append 00 as cents
  };

  if (alwaysZeroCents)
    return addDecimalWithZeroCents(digitsWithPadding, separator)
      .replace('.', ',')
      .replace(/(?=(\d{3})+(\D))\B/g, '.');
  return addDecimalToNumber(digitsWithPadding, separator)
    .replace('.', ',')
    .replace(/(?=(\d{3})+(\D))\B/g, '.');
};

export const formatBRLCurrencyMaskInput = (
  value: string,
  alwaysZeroCents?: boolean,
) => {
  const res = toCurrency(value, alwaysZeroCents);
  return res;
};
